import { render, staticRenderFns } from "./app-key-value-text-inline.vue?vue&type=template&id=79c847bf&"
import script from "./app-key-value-text-inline.vue?vue&type=script&lang=js&"
export * from "./app-key-value-text-inline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports